





























































































































































































const enum STEP {
  REGISTER = 1,
  COMPLETE = 2
}
import { get, sync } from 'vuex-pathify';
import { mapActions } from 'vuex';
import { FormRules } from '@/mixins/FormRules';
import Vue from 'vue';

export default Vue.extend({
  name: 'AuthSignUpWizard',
  mixins: [FormRules],

  data: () => ({
    showPassword: false,

    registerData: {
      firstName: '',
      lastName: '',
      email: '',
      password1: '',
      password2: ''
    },

    step: STEP.REGISTER
  }),

  computed: {
    registerLoading: get('registration/getLoading'),
    getError: get('error/getError'),
    companyName: sync('app/companyName'),
    darkCompanyImage: sync('app/darkCompanyImage'),

    firstButton: function() {
      switch (this.step) {
        case 1:
          return 'Sign In';
        default:
          return 'Back';
      }
    }
  },

  methods: {
    ...mapActions({
      register: 'registration/register',
      clearError: 'error/clearError'
    }),

    back(): number {
      return this.step--;
    },

    next(): number {
      return this.step++;
    },

    secondaryCardButton: function() {
      switch (this.step) {
        case 1:
          return this.$router.push({ name: 'sign-in' });
        case 2:
          return this.back();
        default:
          return this.back();
      }
    },

    primaryCardButton: function() {
      switch (this.step) {
        case 1:
          return this.createAccount(this.registerData);
        case 2:
          return this.$router.push({ name: 'sign-in' });

        default:
          return 'Account created';
      }
    },

    async createAccount(registerData: object) {
      await this.register(registerData).then(() => {
        this.next();
      });
    }
  }
});
